import React, { Component } from 'react';
import autobind from 'react-autobind';
import translate from 'app/translations';

import './NextSteps.scss';

import newsletter from 'assets/images/newsletter.svg';


export class NextSteps extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    return (
      <div className="next-steps card-container box-shadow">
        <div className="align-center">
          <div className="next-steps-wrap">
            <h1>Email Verification</h1>
            <div>
              <div className="img-wrap">
                <img src={newsletter} alt="newsletter" />
              </div>
              <h2 className="orange-text m-tb-16">
                A verification link has been sent to your email account.
              </h2>
              <p className="m-tb-16">
                Please click the link that has has just been sent to your email account to verify your email and continue the registration process.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NextSteps;
